import { YStack } from './Containers';

export const BlinkingDot = () => {
  // eslint-disable-next-line tailwindcss/no-custom-classname
  return <YStack className="blinking-effect size-sm bg-textPrimary rounded-full" />;
};
